import React from 'react';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import AssessmentIcon from '@material-ui/icons/Assessment';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import DataTable from '../_Shared/DataTables/DataTable';
import CreateModal from '../_Shared/CreateModal';
import AppContent from '../_Shared/Layout/AppContent';

const defaultAdvertiser = { name: '', postClickLookback: 30, postViewLookback: 30, costModifier: 1.25, acl: [], brands: [] }
const uuidv4 = require('uuid/v4');

class AdvertiserList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showCreateModal: false,
            advertiser: defaultAdvertiser,
            anchorEl: null
        }

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showCreateModal } = this.state;
        this.setState({ showCreateModal: !showCreateModal, advertiser: defaultAdvertiser });
    }

    handleInputChange = event => {
        const { target: { name, value } } = event;
        this.setState((prevState, state) => {
            return {
                advertiser: Object.assign({}, prevState.advertiser, { [name]: value, })
            }
        });
    }
    
    selectElement = advertiser => {
        this.setState({ advertiser });
    }

    createAdvertiser = e => {
        const { onAdvertiserAdded } = this.props;
        const { advertiser } = this.state;
        onAdvertiserAdded(Object.assign({}, advertiser, { id: uuidv4().replace(/-/g, '') }));
        this.setState({ showCreateModal: false });
    }

    deleteAdvertiser = event => {
        const { onAdvertiserRemoved } = this.props;
        const { advertiser } = this.state;
        onAdvertiserRemoved(advertiser);
        this.setState({ advertiser: defaultAdvertiser, anchorEl: null });
    }

    loadAdvertisers = () => {
        const { onLoadAdvertisers, advertisers, processing } = this.props;
        if(!processing) { onLoadAdvertisers(advertisers); }
    }

    render() {
        const { advertisers, onEdit, loading, processing } = this.props;
        const { showCreateModal, advertiser, anchorEl } = this.state;
        return (<AppContent>
            {
                (loading || processing) && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Advertisers" numSelected={0}>
                <Tooltip title="Add New">
                    <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                advertisers.items &&
                <DataTable columns={[{ label: 'Name', field: 'name' }]} anchorEl={anchorEl} toggleRowMenu={this.toggleRowMenu} 
                    onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu} rows={advertisers.items} 
                    nextToken={advertisers.nextToken} onLoad={this.loadAdvertisers}>
                    <MenuItem onClick={() => onEdit(`/organisations/advertisers/${advertiser.id}/manage/settings`, advertiser)}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <MenuItem onClick={() => onEdit(`/organisations/advertisers/${advertiser.id}/manage/reports`, advertiser)}>
                        <ListItemIcon><AssessmentIcon /></ListItemIcon>
                        <ListItemText inset primary="Reports" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteAdvertiser}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create Advertiser" open={showCreateModal} closeHandler={this.toggleCreateModal} saveHandler={this.createAdvertiser}>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        <TextField autoFocus value={advertiser.name} onChange={this.handleInputChange} id="name" name="name" label="Advertiser Name" type="text" fullWidth />
                    </Grid>
                </Grid>
                <Grid container item spacing={24} >
                    <Grid item lg={6}>
                        <TextField value={advertiser.postClickLookback} onChange={this.handleInputChange} id="postClickLookback" name="postClickLookback" label="Post Click Lookback" type="number" />
                    </Grid>
                    <Grid item lg={6}>
                        <TextField value={advertiser.postViewLookback} onChange={this.handleInputChange} id="postViewLookback" name="postViewLookback" label="Post View Lookback" type="number" />
                    </Grid>
                </Grid>
                <Grid container item spacing={24}>
                    <Grid item lg={6}>
                        <TextField value={advertiser.costModifier} onChange={this.handleInputChange} id="costModifier" name="costModifier" label="Cost Modifier" type="number" />
                    </Grid>
                </Grid>
            </CreateModal>
        </AppContent>)
    }
}

export default AdvertiserList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Advertisers/AdvertiserList.js